export default __webpack_public_path__ + "static/media/IntenseDark.ef282a6a.jpg";